/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { ChangeDetectorRef, Component, Input, ViewChild } from '@angular/core';
import { I18nService } from '@dm/core';
import { MO } from 'app/common/constants';
import { type Port } from 'app/common/types/mo';
import { PortGroupMemberTypeE } from 'app/feature/service/block-service/port-group/port-group.const';
import { type Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { InfigoService } from '../../../infigo.service';
import { RefreshComponent } from '../../RefreshComponent';
import { MemberPortTableComponent } from '../../resource-table/member-port-table/member-port-table.component';

@Component({
    selector: 'app-port-group-resource',
    templateUrl: './port-group-resource.component.html',
    styleUrls: ['../../resource.scss'],
})
export class PortGroupResourceComponent extends RefreshComponent {
    @Input() data;
    @ViewChild('memberPortTable', { static: true })
    memberPortTable: MemberPortTableComponent;
    firstTabItem = this.i18n.get('host.portGroup_view_memberPort_title');
    defaultActiveItem = this.firstTabItem;
    portGroupId;
    portType = '';
    portList: Port[] = [];
    $destroy = new Subject<void>();
    loading = true;
    propName = 'data';

    constructor(
        private i18n: I18nService,
        public infigoService: InfigoService,
        public changeDetectorRef: ChangeDetectorRef,
    ) {
        super();
    }

    // 获取portType
    requestInfo(): Observable<any> {
        this.portGroupId = this.data && (this.data.ID || this.data.actionParams);
        return this.infigoService.getPortGroup(this.portGroupId).pipe(takeUntil(this.$destroy));
    }

    // 根据portType获取逻辑/非逻辑端口
    handleRequest(value: { data: { portType: string } }): void {
        this.portType = value.data.portType;
        if (this.portType === PortGroupMemberTypeE.Lif) {
            this.infigoService
                .getPortGroupAssociateLif(this.portGroupId)
                .pipe(takeUntil(this.$destroy)).subscribe((res) => {
                    this.portList = res;
                    this.loading = false;
                    this.clearTimer();
                    this.updateLoading = false;
                    this.changeDetectorRef.detectChanges();
                });
        } else {
            this.infigoService
                .getAssociatePorts(this.portGroupId)
                .pipe(takeUntil(this.$destroy)).subscribe((res) => {
                    res.forEach((item) => item.newType = item.TYPE === MO.ETH_PORT_TYPE ?
                        `${item.TYPE}_${item.physicalType}` :
                        item.TYPE.toString());
                    this.portList = res;
                    this.loading = false;
                    this.clearTimer();
                    this.updateLoading = false;
                    this.changeDetectorRef.detectChanges();
                });
        }
    }
}
